import React, { useState, useEffect } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaFilter, FaCheck } from 'react-icons/fa';
import DatePicker from '../../../../components/utils/datepicker';
import Paginacao from '../../../../components/utils/paginacao';
import CurrencyInput from 'react-currency-input-field';
import moment from 'moment';

const BuscarLancamento = ({ transacao, contaBancariaId, onClose, onSelecionar }) => {

    const [lancamentos, setLancamentos] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const limit = 10;
    const [filtros, setFiltros] = useState({
        data_inicio: transacao.data_transacao ? new Date(transacao.data_transacao + 'T12:00:00') : null,
        data_fim: transacao.data_transacao ? new Date(transacao.data_transacao + 'T12:00:00') : null,
        valor_min: '',
        valor_max: '',
        descricao: ''
    });

    const [buscaInicial, setBuscaInicial] = useState(false);

    useEffect(() => {
        if (transacao.data_transacao) {
            const dataTransacao = new Date(transacao.data_transacao + 'T12:00:00');
            const dataInicio = new Date(dataTransacao);
            dataInicio.setDate(dataInicio.getDate() - 3);
            const dataFim = new Date(dataTransacao);
            dataFim.setDate(dataFim.getDate() + 3);

            setFiltros(prev => ({
                ...prev,
                data_inicio: dataInicio,
                data_fim: dataFim
            }));
            setBuscaInicial(true);
        }
    }, [transacao]);

    useEffect(() => {
        if (buscaInicial) {
            handleBuscar();
            setBuscaInicial(false);
        }
    }, [buscaInicial]);

    useEffect(() => {
        if (!buscaInicial && totalRegistros > 0) {
            handleBuscar();
        }
    }, [currentPage]);

    const handleBuscar = async () => {
        setCarregando(true);
        try {
            const params = {
                conta_bancaria_id: contaBancariaId,
                page: currentPage,
                limit,
                tipo_financeiro: transacao.tipo === 'debito' ? 'despesa' : 'receita'
            };

            if (filtros.data_inicio) {
                params.data_inicio = moment(filtros.data_inicio).format('YYYY-MM-DD');
            }
            if (filtros.data_fim) {
                params.data_fim = moment(filtros.data_fim).format('YYYY-MM-DD');
            }
            if (filtros.valor_min) {
                const valorMinLimpo = filtros.valor_min.toString().replace(/\./g, '').replace(',', '.');
                params.valor_min = parseFloat(valorMinLimpo);
            }
            if (filtros.valor_max) {
                const valorMaxLimpo = filtros.valor_max.toString().replace(/\./g, '').replace(',', '.');
                params.valor_max = parseFloat(valorMaxLimpo);
            }
            if (filtros.descricao) {
                params.descricao = filtros.descricao;
            }

            const response = await api.get('/conciliacao/buscar-lancamentos', { params });
            setLancamentos(response.data.lancamentos || []);
            setTotalPages(response.data.totalPaginas || 1);
            setTotalRegistros(response.data.totalRegistros || 0);

        } catch (error) {
            Swal.fire('Erro', 'Erro ao buscar lançamentos', 'error');
        } finally {
            setCarregando(false);
        }
    };

    const handleFiltrar = () => {
        setCurrentPage(1);
        handleBuscar();
    };

    const handleLimpar = () => {
        setFiltros({
            data_inicio: null,
            data_fim: null,
            valor_min: '',
            valor_max: '',
            descricao: ''
        });
        setCurrentPage(1);
    };

    const handleSelecionar = async (lancamento) => {
        const result = await Swal.fire({
            title: 'Confirmar Conciliação',
            html: `
                <div class="text-start">
                    <p class="mb-2"><strong>Transação Bancária:</strong></p>
                    <p class="mb-1 ps-3"><strong>Descrição:</strong> ${transacao.descricao_original || '-'}</p>
                    <p class="mb-3 ps-3"><strong>Data:</strong> ${formatarData(transacao.data_transacao)} | <strong>Valor:</strong> ${transacao.tipo === 'debito' ? '-' : ''}${formatarValor(Math.abs(transacao.valor))}</p>
                    <p class="mb-2"><strong>Lançamento:</strong></p>
                    <p class="mb-1 ps-3"><strong>Nº:</strong> ${lancamento.id}${lancamento.numero_doc ? ` | <strong>Doc:</strong> ${lancamento.numero_doc}` : ''}</p>
                    <p class="mb-1 ps-3"><strong>Descrição:</strong> ${lancamento.descricao || '-'}</p>
                    <p class="mb-0 ps-3"><strong>Data:</strong> ${formatarData(lancamento.data_movimento)} | <strong>Valor:</strong> ${formatarValor(lancamento.valor)}</p>
                </div>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sim, conciliar',
            cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
            onSelecionar(lancamento.id);
        }
    };

    const formatarData = (dataString) => {
        if (!dataString) return '-';
        if (dataString.includes('T')) {
            dataString = dataString.split('T')[0];
        }
        if (dataString.includes('-')) {
            const [ano, mes, dia] = dataString.split('-');
            return `${dia}/${mes}/${ano}`;
        }
        return dataString;
    };

    const formatarValor = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Buscar Lançamento</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card info-card mb-3">
                            <div className="card-body p-3">
                                <p className="mb-1">
                                    <strong>Descrição:</strong> {transacao.descricao_original}
                                </p>
                                <p className="mb-0">
                                    <strong>Data:</strong> {formatarData(transacao.data_transacao)} | <strong>Valor:</strong> {transacao.tipo === 'debito' ? '-' : ''}{formatarValor(Math.abs(transacao.valor))}
                                </p>
                            </div>
                        </div>

                        <div className="row mb-3 align-items-end">
                            <div className="col-lg-3 col-12">
                                <label className="form-label fw-bold">Data De</label>
                                <DatePicker
                                    selected={filtros.data_inicio}
                                    onChange={(date) => setFiltros(prev => ({ ...prev, data_inicio: date }))}
                                />
                            </div>
                            <div className="col-lg-3 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Data Até</label>
                                <DatePicker
                                    selected={filtros.data_fim}
                                    onChange={(date) => setFiltros(prev => ({ ...prev, data_fim: date }))}
                                />
                            </div>
                            <div className="col-lg-3 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Valor Mín</label>
                                <CurrencyInput
                                    placeholder="R$ 0,00"
                                    value={filtros.valor_min}
                                    decimalsLimit={2}
                                    decimalSeparator=","
                                    groupSeparator="."
                                    prefix="R$ "
                                    className="form-control"
                                    onValueChange={(value) => setFiltros(prev => ({ ...prev, valor_min: value || '' }))}
                                />
                            </div>
                            <div className="col-lg-3 col-12 mt-3 mt-lg-0">
                                <label className="form-label fw-bold">Valor Máx</label>
                                <CurrencyInput
                                    placeholder="R$ 0,00"
                                    value={filtros.valor_max}
                                    decimalsLimit={2}
                                    decimalSeparator=","
                                    groupSeparator="."
                                    prefix="R$ "
                                    className="form-control"
                                    onValueChange={(value) => setFiltros(prev => ({ ...prev, valor_max: value || '' }))}
                                />
                            </div>
                        </div>
                        <div className="row mb-3 align-items-end">
                            <div className="col-lg-9 col-12">
                                <label className="form-label fw-bold">Descrição</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={filtros.descricao}
                                    onChange={(e) => setFiltros(prev => ({ ...prev, descricao: e.target.value }))}
                                />
                            </div>
                            <div className="col-lg-3 col-12 mt-3 mt-lg-0 d-flex align-items-end justify-content-end">
                                <button className="btn btn-outline-secondary me-2" onClick={handleLimpar}>
                                    Limpar
                                </button>
                                <button className="btn btn-custom-primary" onClick={handleFiltrar}>
                                    <FaFilter className="me-1" /> Filtrar
                                </button>
                            </div>
                        </div>

                        {carregando ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark sticky-top">
                                        <tr>
                                            <th className="text-nowrap">Nº</th>
                                            <th className="text-nowrap">Data</th>
                                            <th className="text-nowrap">Descrição</th>
                                            <th className="text-nowrap">Categoria</th>
                                            <th className="text-nowrap text-end">Valor</th>
                                            <th className="text-nowrap text-center">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lancamentos.length > 0 ? (
                                            lancamentos.map((lancamento) => (
                                                <tr key={lancamento.id}>
                                                    <td className="text-nowrap">
                                                        #{lancamento.id}{lancamento.numero_doc ? ` (${lancamento.numero_doc})` : ''}
                                                    </td>
                                                    <td className="text-nowrap">
                                                        {formatarData(lancamento.data_movimento)}
                                                    </td>
                                                    <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={lancamento.descricao || ''}>
                                                        {lancamento.descricao || '-'}
                                                    </td>
                                                    <td style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={lancamento.categoria?.nome || ''}>
                                                        {lancamento.categoria?.nome || '-'}
                                                    </td>
                                                    <td className={`text-nowrap text-end fw-bold ${parseFloat(lancamento.valor) >= 0 ? 'text-success' : 'text-danger'}`}>
                                                        {formatarValor(lancamento.valor)}
                                                    </td>
                                                    <td className="text-nowrap text-center">
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => handleSelecionar(lancamento)}
                                                            title="Selecionar este lançamento"
                                                        >
                                                            <FaCheck className="me-1" /> Selecionar
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">
                                                    Nenhum lançamento encontrado
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {!carregando && totalRegistros > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span>Total de registros: <strong>{totalRegistros}</strong></span>
                                <Paginacao
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={setCurrentPage}
                                />
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BuscarLancamento;
